<template>
    <div>
        <main-header></main-header>
        <div class="main-page-content">
            <div class="side">
                <div class="animate-wrapper">
                    <div class="top-gradient"></div>
                    <a href="/live" ><img src="/img/app_list_main.png" class="animate-image"></a>
                    <div class="bottom-gradient"></div>
                </div>
            </div>
            <div class="main">
                <h1>Platform #1 <br> for hypercasual <br> developers</h1>
                <p class="description">Realtime app stores tracker. The newest games <br> in App Store and Google Play from
                    all over the World.
                </p>
                <p class="mobile-description">Realtime app stores tracker. The newest games in App Store and Google Play
                    from all over the World.
                </p>
                <div class="social-main">
                    <div class="social">
                        <p class="social-description">Every day we publish <br> video reviews <br> on new hypercasual games.
                        </p>
                        <div class="icons">
                            <a href="https://instagram.com/storeglide?igshid=kkso8smkzn13" target="_blank">
                                <img src="/img/instagram.svg" class="instagram"></a>
                            <a href="https://vt.tiktok.com/yqTjdN/" target="_blank">
                                <img src="/img/tik-tok.svg" class="tik-tok"></a>
                            <a href="https://t.me/storeglide" target="_blank">
                                <img src="/img/telegram.svg" class="telegram"></a>
                        </div>
                    </div>

                    <instagram-widget hide-social="true"></instagram-widget>
                </div>

            </div>
            <div class="mobile-block" id="ios">
                <h1>Instant APP STORE <br> country changer</h1>
                <span class="devices">iPhone | iPad | MacOS</span>

                <select id="countries" onchange="MakeMagic();" class="custom-select">
                    <option selected=""> CHOOSE COUNTRY</option>

                    <option disabled="">★ MOST POPULAR</option>

                    <option value="AU">Australia</option>
                    <option value="CA">Canada</option>
                    <option value="CN">China</option>
                    <option value="FR">France</option>
                    <option value="DE">Germany</option>
                    <option value="IT">Italy</option>
                    <option value="JP">Japan</option>
                    <option value="NL">Netherlands</option>
                    <option value="NZ">New Zealand</option>
                    <option value="RU">Russia</option>
                    <option value="SG">Singapore</option>
                    <option value="KR">South Korea</option>
                    <option value="ES">Spain</option>
                    <option value="SE">Sweden</option>
                    <option value="CH">Switzerland</option>
                    <option value="GB">United Kingdom</option>
                    <option value="US">United States</option>

                    <option disabled="">⚑ A-Z</option>

                    <option value="al">Albania</option>
                    <option value="DZ">Algeria</option>
                    <option value="AO">Angola</option>
                    <option value="AI">Anguilla</option>
                    <option value="AG">Antigua and Barbuda</option>
                    <option value="AR">Argentina</option>
                    <option value="AM">Armenia</option>
                    <option value="AU">Australia</option>
                    <option value="AT">Austria</option>
                    <option value="AZ">Azerbaijan</option>
                    <option disabled="">B</option>
                    <option value="BS">Bahamas</option>
                    <option value="BH">Bahrain</option>
                    <option value="BB">Barbados</option>
                    <option value="BY">Belarus</option>
                    <option value="BE">Belgium</option>
                    <option value="BZ">Belize</option>
                    <option value="BJ">Benin</option>
                    <option value="BM">Bermuda</option>
                    <option value="BT">Bhutan</option>
                    <option value="BO">Bolivia</option>
                    <option value="BW">Botswana</option>
                    <option value="BR">Brazil</option>
                    <option value="VG">British Virgin Islands</option>
                    <option value="BN">Brunei Darussalam</option>
                    <option value="BG">Bulgaria</option>
                    <option value="BF">Burkina Faso</option>
                    <option disabled="">C</option>
                    <option value="CV">Cape Verde</option>
                    <option value="KH">Cambodia</option>
                    <option value="CA">Canada</option>
                    <option value="KY">Cayman Islands</option>
                    <option value="TD">Chad</option>
                    <option value="CL">Chile</option>
                    <option value="CN">China</option>
                    <option value="CO">Colombia</option>
                    <option value="CR">Costa Rica</option>
                    <option value="HR">Croatia</option>
                    <option value="CY">Cyprus</option>
                    <option value="CZ">Czech Republic</option>
                    <option disabled="">D</option>
                    <option value="DK">Denmark</option>
                    <option value="DM">Dominica</option>
                    <option value="DO">Dominican Republic</option>
                    <option disabled="">E</option>
                    <option value="EC">Ecuador</option>
                    <option value="EG">Egypt</option>
                    <option value="SV">El Salvador</option>
                    <option value="EE">Estonia</option>
                    <option disabled="">F</option>
                    <option value="FJ">Fiji</option>
                    <option value="FI">Finland</option>
                    <option value="FR">France</option>
                    <option disabled="">G</option>
                    <option value="GM">Gambia</option>
                    <option value="DE">Germany</option>
                    <option value="GH">Ghana</option>
                    <option value="GR">Greece</option>
                    <option value="GD">Grenada</option>
                    <option value="GT">Guatemala</option>
                    <option value="GW">Guinea-Bissau</option>
                    <option value="GY">Guyana</option>
                    <option disabled="">H</option>
                    <option value="HN">Honduras</option>
                    <option value="HK">Hong Kong</option>
                    <option value="HU">Hungary</option>
                    <option disabled="">I</option>
                    <option value="IS">Iceland</option>
                    <option value="IN">India</option>
                    <option value="ID">Indonesia</option>
                    <option value="IE">Ireland</option>
                    <option value="IL">Israel</option>
                    <option value="IT">Italy</option>
                    <option disabled="">J</option>
                    <option value="JM">Jamaica</option>
                    <option value="JP">Japan</option>
                    <option value="JO">Jordan</option>
                    <option disabled="">K</option>
                    <option value="KZ">Kazakhstan</option>
                    <option value="KE">Kenya</option>
                    <option value="KR">Korea (South)</option>
                    <option value="KW">Kuwait</option>
                    <option value="KG">Kyrgyzstan</option>
                    <option disabled="">L</option>
                    <option value="LA">Lao</option>
                    <option value="LV">Latvia</option>
                    <option value="LB">Lebanon</option>
                    <option value="LR">Liberia</option>
                    <option value="LT">Lithuania</option>
                    <option value="LU">Luxembourg</option>
                    <option disabled="">M</option>
                    <option value="MO">Macao</option>
                    <option value="MK">Macedonia</option>
                    <option value="MG">Madagascar</option>
                    <option value="MW">Malawi</option>
                    <option value="MY">Malaysia</option>
                    <option value="ML">Mali</option>
                    <option value="MT">Malta</option>
                    <option value="MR">Mauritania</option>
                    <option value="MU">Mauritius</option>
                    <option value="MX">Mexico</option>
                    <option value="FM">Micronesia</option>
                    <option value="MD">Moldova</option>
                    <option value="MN">Mongolia</option>
                    <option value="MS">Montserrat</option>
                    <option value="MZ">Mozambique</option>
                    <option disabled="">N</option>
                    <option value="NA">Namibia</option>
                    <option value="NP">Nepal</option>
                    <option value="NL">Netherlands</option>
                    <option value="NZ">New Zealand</option>
                    <option value="NI">Nicaragua</option>
                    <option value="NE">Niger</option>
                    <option value="NG">Nigeria</option>
                    <option value="NO">Norway</option>
                    <option disabled="">O</option>
                    <option value="OM">Oman</option>
                    <option disabled="">P</option>
                    <option value="PK">Pakistan</option>
                    <option value="PW">Palau</option>
                    <option value="PA">Panama</option>
                    <option value="PG">Papua New Guinea</option>
                    <option value="PY">Paraguay</option>
                    <option value="PE">Peru</option>
                    <option value="PH">Philippines</option>
                    <option value="PL">Poland</option>
                    <option value="PT">Portugal</option>
                    <option disabled="">Q</option>
                    <option value="QA">Qatar</option>
                    <option disabled="">R</option>
                    <option value="RO">Romania</option>
                    <option value="RU">Russia</option>
                    <option disabled="">S</option>
                    <option value="KN">St. Kitts and Nevis</option>
                    <option value="LC">St. Lucia</option>
                    <option value="VC">St. Vincent and The Grenadines</option>
                    <option value="SA">Saudi Arabia</option>
                    <option value="SN">Senegal</option>
                    <option value="SC">Seychelles</option>
                    <option value="SL">Sierra Leone</option>
                    <option value="SG">Singapore</option>
                    <option value="SK">Slovakia</option>
                    <option value="SI">Slovenia</option>
                    <option value="SB">Solomon Islands</option>
                    <option value="ZA">South Africa</option>
                    <option value="ES">Spain</option>
                    <option value="LK">Sri Lanka</option>
                    <option value="SR">Suriname</option>
                    <option value="SZ">Swaziland</option>
                    <option value="SE">Sweden</option>
                    <option value="CH">Switzerland</option>
                    <option disabled="">T</option>
                    <option value="TW">Taiwan</option>
                    <option value="TJ">Tajikistan</option>
                    <option value="TZ">Tanzania</option>
                    <option value="TH">Thailand</option>
                    <option value="TT">Trinidad and Tobago</option>
                    <option value="TN">Tunisia</option>
                    <option value="TR">Turkey</option>
                    <option value="TM">Turkmenistan</option>
                    <option value="TC">Turks and Caicos</option>
                    <option disabled="">U</option>
                    <option value="UG">Uganda</option>
                    <option value="UA">Ukraine</option>
                    <option value="AE">United Arab Emirates</option>
                    <option value="GB">United Kingdom</option>
                    <option value="US">United States</option>
                    <option value="UY">Uruguay</option>
                    <option value="UZ">Uzbekistan</option>
                    <option disabled="">V</option>
                    <option value="VE">Venezuela</option>
                    <option value="VN">Vietnam</option>
                    <option disabled="">Y</option>
                    <option value="YE">Yemen</option>
                    <option disabled="">Z</option>
                    <option value="ZW">Zimbabwe</option>

                </select>
                <div class="only-phone">
                    <a target="_blank" onclick="OpenTopCharts();">Top grossing</a>
                    <span>old design app store iOS only</span>
                </div>

            </div>
            <div class="social-main mobile">
                <div class="social">
                    <p class="social-description">Every day we publish <br> video reviews <br> on new hypercasual games.
                    </p>
                    <div class="icons">
                        <a href="https://instagram.com/storeglide?igshid=kkso8smkzn13" target="_blank">
                            <img src="/img/instagram.svg" class="instagram"></a>
                        <a href="https://vt.tiktok.com/yqTjdN/" target="_blank">
                            <img src="/img/tik-tok.svg" class="tik-tok"></a>
                        <a href="https://t.me/storeglide" target="_blank">
                            <img src="/img/telegram.svg" class="telegram"></a>
                    </div>
                </div>

                <instagram-widget hide-social="true"></instagram-widget>
            </div>
            <!--        <div class="blog mobile">-->
            <!--            <p class="title">Our market research for hypercasual games</p>-->
            <!--            <div class="author">-->
            <!--                <img src="/img/pavel.png">-->
            <!--                <p class="name">Pavel Karabanov</p>-->
            <!--                <span>Head of hypercasual in HighCore</span>-->
            <!--                <p class="description">When you visit the Site, we and certain third-party services (“Service Provider”)-->
            <!--                    such as Google Analytics, may automatically collect certain information about you when you access or-->
            <!--                    use the Site (“Usage Information”). Usage Information may include but is not limited to your IP-->
            <!--                    address d to your IP address d to your IP address.</p>-->
            <!--                <div class="more-block">-->
            <!--                    <a class="btn" href="/blog">Read more-->
            <!--                    </a>-->
            <!--                </div>-->
            <!--            </div>-->

            <!--        </div>-->
            <!--        <div class="blog" >-->
            <!--            <div class="author">-->
            <!--                <img src="/img/pavel.png">-->
            <!--                <p class="name">Pavel Karabanov</p>-->
            <!--                <span>Head of hypercasual in HighCore</span>-->
            <!--                <p class="description">When you visit the Site, we and certain third-party services (“Service Provider”)-->
            <!--                    such as Google Analytics, may automatically collect certain information about you when you access or-->
            <!--                    use the Site (“Usage Information”). Usage Information may include but is not limited to your IP-->
            <!--                    address d to your IP address d to your IP address.</p>-->
            <!--            </div>-->
            <!--            <div class="more-block">-->
            <!--                <p>Our market research for hypercasual games</p>-->
            <!--                <a class="btn" href="/blog">Read more-->
            <!--                </a>-->
            <!--            </div>-->
            <!--        </div>-->
        </div>
        <mobile-menu></mobile-menu>
    </div>
</template>

<script>
import MainHeader from './custom/MainHeaderComponent';
import MobileMenu from './custom/MobileMenuComponent';

export default {
    components: {
        MainHeader,
        MobileMenu
    },
    data () {
        return {
            scrollMagickController: null,
            scene: null,
        };
    },
    created() {
        window.addEventListener("resize", this.resizeHandler);
    },
    mounted() {
        this.$nextTick(() => {
            if (!this.isMobile()) {
                this.initScrollMagick();
            }
        });
        $('footer').addClass('footer-main');
    },
    methods: {
        resizeHandler(e) {
            if(this.isMobile()) {
                if (this.scrollMagickController) {
                    this.destroyScrollMagick();
                }
            } else {
                if(!this.scrollMagickController) {
                    this.initScrollMagick();
                }
            }
        },
        initScrollMagick() {
            this.scrollMagickController = new ScrollMagic.Controller();
            this.scene = new ScrollMagic.Scene({
                triggerElement: ".content-wrapper",
                duration: 600,
                triggerHook: 0,
            })
                .setTween(".animate-image", 0.5, {yPercent: -58})
                .setPin(".content-wrapper")
                .addTo(this.scrollMagickController);
        },
        destroyScrollMagick() {
            this.scrollMagickController.destroy(true);
            this.scrollMagickController = null;
            this.scene = null;
        },
        isMobile() {
            let width = window.innerWidth;
            return width < 991;
        },
        submit () {
            this.$refs.checkoutRef.redirectToCheckout();
        },
    }
}

</script>
